module.exports = __webpack_public_path__ + "img/pixelate.05ebe338.png";